import {
  PROMO_CODES,
  PROMO_CODES_MODAL,
  PROMO_CODES_CREATED_NUMBER,
  PRODUCT_BATCHES_ROW_DATA,
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  ON_SELECT_PRODUCT_DATA,
  GENERAL_IMPORT_PRODUCT_DATA,
} from "../../constants/ActionTypes";
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_PRODUCTS_COLUMNS,
  INDEX_DB_TABLES,
  PRODUCT_INDEX_KEY,
  PRODUCT_NAME_INDEX,
} from "../../constants/IndexDBData";
import ds from "../../Services/DataServices";
import {
  saveEntitiesDatatoIndexBD,
  saveUpdateEntitiesToIndexedDB,
} from "./IndexDBActions";

export function loadPromoCodes(loadValue) {
  return (dispatch) => {
    dispatch({ type: PROMO_CODES, payload: loadValue });
  };
}
export function loadPromoCodesModal(loadValue) {
  return (dispatch) => {
    dispatch({ type: PROMO_CODES_MODAL, payload: loadValue });
  };
}
export function loadPromoCodesCreatedNbr(loadValue) {
  return (dispatch) => {
    dispatch({ type: PROMO_CODES_CREATED_NUMBER, payload: loadValue });
  };
}
export function loadProductBatchesRowData(loadValue) {
  return (dispatch) => {
    dispatch({ type: PRODUCT_BATCHES_ROW_DATA, payload: loadValue });
  };
}
export function loadFetchProducts(body) {
  return (dispatch) => {
    fetchProducts(dispatch, body);
  };
}
export function loadSearchSelectedProduct(loadValue) {
  return (dispatch) => {
    dispatch({ type: ON_SELECT_PRODUCT_DATA, payload: loadValue });
  };
}
export function loadGeneralImportProducts(loadValue) {
  return (dispatch) => {
    dispatch({ type: GENERAL_IMPORT_PRODUCT_DATA, payload: loadValue });
  };
}
async function fetchProducts(dispatch, body) {
  dispatch({ type: FETCH_PRODUCTS_REQUEST });
  try {
    const getProducts = ds.getAllProductsService(body);
    await getProducts
      .then((response) => {
        if (response && response.length > 0) {
          // Save products to IndexedDB
          //  saveProductsToIndexedDB(response);

          const products =
            response &&
            response.map((product) => {
              return {
                id: product.productID ? product.productID : 0,
                productID: product.productID ? product.productID : 0,
                productName: product.productName ? product.productName : "",
                variantName: product.variantName ? product.variantName : "",
                parentProductID: product.parentProductID
                  ? product.parentProductID
                  : 0,
                isVariant: product.isVariant ? product.isVariant : false,
                isActive: product.isActive ? true : false,
                isActiveOnSale: product.isActiveOnSale ? true : false,
              };
            });

          saveEntitiesDatatoIndexBD(
            response, // products,
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.PRODUCTS
          );

          // saveUpdateEntitiesToIndexedDB(
          //   products,
          //   PRODUCT_INDEX_KEY,
          //   INDEX_DB_NAME,
          //   INDEX_DB_TABLES.PRODUCTS,
          //   PRODUCT_NAME_INDEX,
          //   INDEX_DB_PRODUCTS_COLUMNS.PRODUCT_NAME
          // );
          dispatch({ type: FETCH_PRODUCTS_SUCCESS, payload: response });
        }
      })
      .catch((e) => {
        //dispatch({ type: FETCH_PRODUCTS_FAILURE, payload: error.message });
      });
  } catch (error) {
    dispatch({ type: FETCH_PRODUCTS_FAILURE, payload: error.message });
  }
}

export const saveProductsToIndexedDB = (products) => {
  const indexedDB =
    window.indexedDB ||
    window.mozIndexedDB ||
    window.webkitIndexedDB ||
    window.msIndexedDB ||
    window.shimIndexedDB;
  if (!indexedDB) {
    //console.log("IndexedDB could not be found in this browser.");
  }
  const request = indexedDB.open(INDEX_DB_NAME, 1);
  request.onerror = function (event) {
    console.error("An error occurred with IndexedDB 2");
    console.error(event);
  };
  request.onupgradeneeded = function () {
    const db = request.result;
    const store = db.createObjectStore(INDEX_DB_TABLES.PRODUCTS, {
      keyPath: "id",
    });
    store.createIndex(
      PRODUCT_NAME_INDEX,
      [INDEX_DB_PRODUCTS_COLUMNS.PRODUCT_NAME],
      { unique: false }
    );
  };

  request.onsuccess = function () {
    //console.log("Database opened successfully");
    const db = request.result;

    if (!db.objectStoreNames.contains(INDEX_DB_TABLES.PRODUCTS)) {
      console.error(
        `Object store ${INDEX_DB_TABLES.PRODUCTS} does not exist in the database.`
      );
      return;
    }
    const transaction = db.transaction(INDEX_DB_TABLES.PRODUCTS, "readwrite");
    const store = transaction.objectStore(INDEX_DB_TABLES.PRODUCTS);
    products.forEach((product) => {
      const productObj = {
        id: product.productID ? product.productID : 0,
        productName: product.productName ? product.productName : "",
        variantName: product.variantName ? product.variantName : "",
        parentProductID: product.parentProductID ? product.parentProductID : 0,
        isVariant: product.isVariant ? product.isVariant : false,
      };
      if (productObj.id != 0) {
        store.put(productObj);
      }
    });
    transaction.oncomplete = function () {
      db.close();
    };
  };
};
